// client/src/hooks/usePlataformaNotaFiscal.js
// Nota fiscal da mensalidade SaaS — matriz emitindo em nome da própria
// plataforma, cobrando Franquia/Conta. Espelha useNotaFiscal.js, mas contra
// o namespace /plataforma-notas-fiscais (config única, sem accountId).
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const errMsg = (err, fallback) => err.response?.data?.error || err.response?.data?.message || fallback;

// ---------------------------------------------------------------------
// Config (única, da plataforma)
// ---------------------------------------------------------------------

export const usePlataformaNotaFiscalConfig = () => useQuery({
    queryKey: ['plataforma-nota-fiscal', 'config'],
    queryFn: () => apiClient.get('/plataforma-notas-fiscais/config').then((r) => r.data.data),
});

export const useSalvarPlataformaNotaFiscalConfig = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (payload) => apiClient.put('/plataforma-notas-fiscais/config', payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['plataforma-nota-fiscal', 'config'] });
            setAlert('Configuração de nota fiscal da plataforma salva com sucesso.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao salvar configuração de nota fiscal da plataforma.'), 'danger'),
    });
};

// ---------------------------------------------------------------------
// Notas emitidas (mensalidade de Franquia/Conta)
// ---------------------------------------------------------------------

export const usePlataformaNotasFiscais = (params = {}) => useQuery({
    queryKey: ['plataforma-nota-fiscal', 'lista', params],
    queryFn: () => apiClient.get('/plataforma-notas-fiscais', { params }).then((r) => r.data),
    placeholderData: (prev) => prev,
});

export const useReemitirPlataformaNotaFiscal = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (id) => apiClient.post(`/plataforma-notas-fiscais/${id}/reemitir`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['plataforma-nota-fiscal', 'lista'] });
            setAlert('Reemissão disparada.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao reemitir nota fiscal.'), 'danger'),
    });
};

export const useConsultarStatusPlataformaNotaFiscal = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (id) => apiClient.post(`/plataforma-notas-fiscais/${id}/consultar-status`),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['plataforma-nota-fiscal', 'lista'] });
            setAlert(`Status atualizado: ${res.data.data.status}.`, 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao consultar status junto ao provedor.'), 'danger'),
    });
};
